module.exports = __webpack_public_path__ + "assets/img/btn-detail-0ab290fe.png";